import { Box } from '@mui/material';
import React, { ReactElement } from 'react';
import { dashboardContainerSx } from './styles';
import type { AnalyticsDashboardPresentationalProps } from './types';

function AnalyticsDashboardPresentational({
  issuesSection,
  inspectionsSection,
}: AnalyticsDashboardPresentationalProps): ReactElement {
  return (
    <Box sx={dashboardContainerSx}>
      {issuesSection}
      {inspectionsSection}
    </Box>
  );
}

export const MemoAnalyticsDashboardPresentational = React.memo(
  AnalyticsDashboardPresentational
);
